<div class="layout-wrapper">
  <div class="layout-topbar">
    <app-topbar />
  </div>
  <div class="layout-main-container">
    <div class="layout-main">
      <div class="layout-main-inner">
        <router-outlet></router-outlet>
      </div>
    </div>
    <!-- <app-footer></app-footer> -->
  </div>
</div>
